import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import SEOHead from '../components/SEOHead';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { playerService } from '../services/playerService';
import { useToast } from '../hooks/use-toast';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Login = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const buttonRef = useRef(null);
  const [configured, setConfigured] = useState(null);

  useEffect(() => {
    let cancelled = false;
    playerService.getConfig()
      .then((data) => { if (!cancelled) setConfigured(data.google_oauth_configured); })
      .catch(() => { if (!cancelled) setConfigured(false); });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!configured || !buttonRef.current) return;

    const handleCredentialResponse = async (response) => {
      try {
        const result = await playerService.googleLogin(response.credential);
        localStorage.setItem('playerToken', result.access_token);
        localStorage.setItem('playerAuth', JSON.stringify(result.player));
        navigate('/profile');
      } catch (error) {
        toast({ title: 'Sign-in failed', description: 'Please try again.', variant: 'destructive' });
      }
    };

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
    });
    window.google.accounts.id.renderButton(buttonRef.current, { theme: 'outline', size: 'large' });
  }, [configured, navigate, toast]);

  return (
    <Layout>
      <SEOHead
        title="Sign In - BookQuiz"
        description="Sign in to BookQuiz to track your quiz stats, build a streak, and climb the leaderboard."
        url="/login"
      />
      <div className="min-h-screen flex items-center justify-center px-4">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle>Sign in to BookQuiz</CardTitle>
          </CardHeader>
          <CardContent>
            {configured === null && <p>Loading...</p>}
            {configured === false && <p>Sign-in is not available right now.</p>}
            {configured === true && <div ref={buttonRef} />}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default Login;
